<template>
  <div class="fl-header">
    <div>
      <fl-logo
        class="fl-header__logo"
        @click="goToMain"
      />
      <ui-icon
        class="fl-header__icon"
        name="uiBars"
        :size="25"
        @click="toggleMobileMenu"
      />
    </div>
    <fl-header-profile />
  </div>
</template>

<script>
import FlLogo from "@/components/FlLogo.vue";
import FlHeaderProfile from "@/layouts/FlHeader/FlHeaderProfile.vue";
import UiIcon from "@iflat-ui/components/icons/UiIcon.vue"

import {useLayoutStore} from "@/store/layout";
import {CABINET_MAIN_PAGE} from "@/router/routerConst";
export default {
  components: {FlLogo, FlHeaderProfile, UiIcon},
  data() {
    return {
      layoutStore: useLayoutStore()
    }
  },
  methods: {
    toggleMobileMenu() {
      this.layoutStore.toggleMobileMenu()
    },
    goToMain () {
      this.$router.push({ name: CABINET_MAIN_PAGE })
    }
  }
}
</script>

<style lang="scss" scoped>
.fl-header {
  @include flex-space-between;
  min-height: 74px;
  padding: 12px 24px;
  box-shadow: inset 0 -1px 0 0 rgba($black, 0.1);

  &__logo {
    cursor: pointer;
  }

  @include media-min-lg {
    &__icon {
      display: none;
    }
  }

  @include media-max-lg {
    &__logo {
      display: none;
    }
  }
}
</style>
